export default __webpack_public_path__ + "static/media/Cow-01.b0b1849d.svg";